import {
  FC, memo, useCallback, useEffect, useMemo,
} from 'react';

import ModalCashAvailableList from 'app/components/common/gift/elements/ModalCashAvailableList';
import { useDispatcher } from 'app/store/utils/redux/hooks';

const EmbedGiftChange: FC = () => {
  const actions = useDispatcher();

  const { amount, giftCardId } = useMemo(() => {
    const url = new URL(window.location.href);
    return {
      amount: Number(url.searchParams.get('amount')),
      giftCardId: url.searchParams.has('gift_card_id') ? Number(url.searchParams.get('gift_card_id')) : null,
    };
  }, []);

  const hasHeader = useMemo((): boolean => {
    const url = new URL(window.location.href);
    return !url?.searchParams?.get?.('options')?.includes('hide-header');
  }, []);

  const hasConfirm = useMemo((): boolean => {
    const url = new URL(window.location.href);
    return !url?.searchParams?.get?.('options')?.includes('hide-confirm');
  }, []);

  useEffect(() => {
    actions.gift.cashLoadData(amount, giftCardId);
  }, [actions.gift, amount, giftCardId]);

  const postMessage = useCallback((name: string, payload: Record<string, any> = {}) => {
    const { webkit, CardSnacks } = window as any;
    if (typeof webkit?.messageHandlers?.observer?.postMessage !== 'undefined') {
      webkit?.messageHandlers?.observer?.postMessage?.(JSON.stringify({ name, payload }));
    }
    if (typeof CardSnacks?.notifyCardsnacksCashSwap !== 'undefined' && name === 'select') {
      CardSnacks?.notifyCardsnacksCashSwap(payload?.id);
    }
  }, []);

  const handleClose = useCallback(() => {
    postMessage('close');
  }, [postMessage]);

  const handleChoose = useCallback((id: number) => {
    postMessage('select', { id });
  }, [postMessage]);

  const handleClosed = useCallback(() => {
  }, []);

  return (
    <>
      <ModalCashAvailableList
        isOpened
        isFixed
        hasHeader={hasHeader}
        hasConfirm={hasConfirm}
        amount={amount}
        onClose={handleClose}
        onChoose={handleChoose}
        onClosed={handleClosed}
      />
    </>
  );
};

export default memo(EmbedGiftChange);
